import { render, staticRenderFns } from "./CouponItem.vue?vue&type=template&id=51162c5e&scoped=true&"
import script from "./CouponItem.vue?vue&type=script&lang=js&"
export * from "./CouponItem.vue?vue&type=script&lang=js&"
import style0 from "./CouponItem.vue?vue&type=style&index=0&id=51162c5e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51162c5e",
  null
  
)

component.options.__file = "src/components/coupon-item/CouponItem.vue"
export default component.exports